import classNames from 'classnames'

interface ContentWrapperProps {
  children: React.ReactNode
  className?: React.ComponentProps<'div'>['className']
}

const ProcessContent = ({ children, className }: ContentWrapperProps) => {
  return <div className={classNames(`h-full w-full flex-1 ${className} overflow-y-scroll`)}>{children}</div>
}

export default ProcessContent
